import userActions from './userActions';
import contentActions from './contentActions';
import adminActions from './adminActions';
import roomActions from './roomActions';

const allActions = {
    userActions, contentActions, adminActions, roomActions
}

export default allActions;